import { useState } from "react"
import { XIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

interface Props {
  match: string[]
  onChange: (match: string[]) => void
}

export function MatchSection({ match, onChange }: Props) {
  const [rows, setRows] = useState<string[]>(match)

  function commit(next: string[]) {
    setRows(next)
    onChange(next.map(row => row.trim()).filter(Boolean))
  }

  function updateRow(index: number, value: string) {
    commit(rows.map((row, i) => i === index ? value : row))
  }

  function addRow() {
    commit([...rows, ""])
  }

  function removeRow(index: number) {
    commit(rows.filter((_, i) => i !== index))
  }

  return <div className="flex flex-col gap-2">
    <h3 className="text-sm font-medium">Other ways of saying it</h3>
    {rows.map((row, index) => <div key={index} className="flex items-center gap-2">
      <Input value={row} onChange={e => updateRow(index, e.target.value)} placeholder="synonym" className="flex-1" />
      <Button variant="ghost" size="icon-xs" aria-label="Remove synonym" onClick={() => removeRow(index)}><XIcon /></Button>
    </div>)}
    <Button variant="outline" size="sm" onClick={addRow} className="self-start">Add synonym</Button>
  </div>
}
